import _asyncToGenerator from "/var/www/verifynest/resources/assets/js/qportal/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/var/www/verifynest/resources/assets/js/qportal/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import Http from '@/services/Http';
import moment from 'moment';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var app, store, Vue, client;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            app = _ref.app, store = _ref.store, Vue = _ref.Vue;
            client = Http.client();
            client.interceptors.response.use(function (response) {
              store.dispatch('user/setUserLastRequest', moment());
              return response;
            });
            Vue.prototype.$axios = client;

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
})();